export const logUserOut = (status: any) => {
  if (Number(status) === 593) {
    localStorage.clear();
    window.location.reload();
  }
};
